import { jsx as _jsx } from "react/jsx-runtime";
import { TableHead as MuiTableHead } from '@mui/material';
import { styled } from '@mui/material/styles';
const StyledTableHead = styled(MuiTableHead)(() => ({}));
function TableHead(props) {
    return _jsx(StyledTableHead, { ...props });
}
export default TableHead;
